export default "__VITE_ASSET__DIXQno1p__"